/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { JobApplication } from "@/data/job-applications/types/JobApplication";
import { RelatedEntitiesTabs } from "@/views/related";

interface JobApplicationDetailsRelatedTabProps {
  jobApplication: JobApplication;
}

export const JobApplicationDetailsRelatedTab: FC<JobApplicationDetailsRelatedTabProps> = ({ jobApplication }) => {
  return jobApplication.relatedEntities ? (
    <RelatedEntitiesTabs
      relatedEntities={jobApplication.relatedEntities}
      entityType="job-application"
      entityId={jobApplication.id}
    />
  ) : null;
};
